import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import axios from "axios"

class EnergyWheel {
	constructor() {
		if (document.querySelector("#chartdiv")) {
			axios.defaults.headers.common["X-WP-Nonce"] = academyData.nonce
			this.areasContainer = document.getElementById("energy-wheel").querySelector(".areas");
			this.allAreas = document.getElementById("energy-wheel").getElementsByClassName("area");
			this.toggleHeader = document.getElementById("energy-wheel").querySelector(".toggle-header");
			this.energyWheel = document.getElementById("energy-wheel");
			this.chart = am4core.create("chartdiv", am4charts.RadarChart);
			this.isDemo = document.querySelector(".energy-wheel-demo");

			this.events();
		}
	}

	events() {
		this.areasContainer.addEventListener("click", e => this.clickHandler(e));
		this.toggleHeader.addEventListener("click", () => this.showEnergyWheel());
		this.loadChart();
	}

	clickHandler(e) {
        if (e.target.classList.contains("value")) this.setValue(e);
		if (e.target.classList.contains("modify-values")) this.editValues();
		if (e.target.classList.contains("navigate-values")) this.navigateValue(e);
    }

	async loadChart() {
		try {
			let results = Array.from({length: 9}, () => Math.floor(Math.random() * 10) + 1);

			if (!this.isDemo) {
				const response = await axios.get(academyData.root_url + "/wp-json/academy/v1/manage-energy-wheel");
            	results = response.data;
			}

			am4core.useTheme(am4themes_animated);

			this.chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

			this.chart.data = [ {
				"category": "Ernährung",
				"value": results[0],
				"color": am4core.color("#B0B119")
			}, {
				"category": "Entspannung & Schlaf",
				"value": results[1],
				"color": am4core.color("#7EA924")
			}, {
				"category": "Bewegung & Fitness",
				"value": results[2],
				"color": am4core.color("#4A9D35")
			}, {
				"category": "Empathie",
				"value": results[3],
				"color": am4core.color("#FFB133")
			}, {
				"category": "Familie & Freunde",
				"value": results[4],
				"color": am4core.color("#F49800")
			}, {
				"category": "Innere Harmonie",
				"value": results[5],
				"color": am4core.color("#E08A00")
			}, {
				"category": "Liebe & Dankbarkeit",
				"value": results[6],
				"color": am4core.color("#EA4F96")
			}, {
				"category": "Werte",
				"value": results[7],
				"color": am4core.color("#E782DF")
			}, {
				"category": "Vision",
				"value": results[8],
				"color": am4core.color("#CFB4FF")
			} ];

			this.chart.padding(20, 20, 20, 20);

			let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
			categoryAxis.dataFields.category = "category";
			categoryAxis.renderer.labels.template.location = 0.5;
			categoryAxis.renderer.tooltipLocation = 0.5;
			categoryAxis.renderer.labels.template.fill = am4core.color("#333");

			let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
			valueAxis.renderer.labels.template.disabled = true;
			valueAxis.min = 0;
			valueAxis.max = 10;
			valueAxis.renderer.minGridDistance = 10;

			let series = this.chart.series.push(new am4charts.RadarColumnSeries());
			series.columns.template.tooltipText = "{categoryX}: {valueY.value}";
			series.tooltip.getFillFromObject = false;
			series.tooltip.background.fill = am4core.color("#B0B119");
			series.tooltip.label.fill = am4core.color("#ffffff");
			series.tooltip.background.strokeOpacity = 0;

			series.columns.template.width = am4core.percent(100);
			series.columns.template.strokeWidth = 0;
			series.columns.template.column.propertyFields.fill = "color";
			series.dataFields.categoryX = "category";
			series.dataFields.valueY = "value";

			let valueLabel = series.bullets.push(new am4charts.LabelBullet());
			valueLabel.label.text = "{value}";
			valueLabel.label.fill = am4core.color("#333");
		} catch (e) {
            console.log(e);
        }
	}

	navigateValue(e) {
		let index = parseInt(e.target.dataset.index);
		
		for (let i = 0; i < this.allAreas.length; i++) {
			this.allAreas[i].style.display = (index) === i ? "block" : "none";
		}
	}

	async setValue(e) {
		try {
			let index = parseInt(e.target.dataset.index);
			let value = parseInt(e.target.innerHTML);

			if (!this.isDemo) {
				await axios.post(academyData.root_url + "/wp-json/academy/v1/manage-energy-wheel", { "index": index, "value": value });
			}

			// Set value
			this.chart.data[index].value = value;
			this.chart.invalidateRawData();
			
			// Reveal next question
			for (let i = 0; i < this.allAreas.length; i++) {
				this.allAreas[i].style.display = (index + 1) === i ? "block" : "none";
			}
		} catch (e) {
			console.log(e);
		}
	}

	editValues() {
		for (let i = 0; i < this.allAreas.length; i++) {
			this.allAreas[i].style.display = 0 === i ? "block" : "none";
		}
	}

	async showEnergyWheel() {
		try {
			let visible = true;

			if (this.energyWheel.classList.contains("toggle-active")) {
				visible = false;
			}

			if (!this.isDemo) {
				await axios.post(academyData.root_url + "/wp-json/academy/v1/manage-energy-wheel", { "visible": visible });
			}
		} catch (e) {
			console.log(e);
		}
	}
}

export default EnergyWheel;
